import React from "react";
import Button from "@mui/material/Button";

import "./style.css";
import { IButtonProperties } from "../ButtonParameters";

export interface FlatButtonProperties extends IButtonProperties {
  readonly disableElevation?: boolean;
  readonly className?: string;
  style?: React.CSSProperties;
}

const DEFAULT_PARAMENTERS: FlatButtonProperties = {
  disableElevation: true,
  onClick: () => {},
};

const FlatButton = (flatButtonProperties: FlatButtonProperties) => {
  let _parameters: any = {
    ...DEFAULT_PARAMENTERS,
    ...flatButtonProperties,
  };

  return <Button {..._parameters} color={_parameters?.color || "default"}>{_parameters.text}</Button>;
};

export { FlatButton };
